"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentRequestDisplayItems = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getPaymentRequestDisplayItems() {
    const { line_items, taxes, discounts, fees, shipping } = (0, checkout_frontend_library_1.getApplicationState)();
    const shippingAmount = shipping.selected_shipping ? shipping.selected_shipping.amount : 0;
    let totalTaxes = 0, totalFees = 0, totalDiscounts = 0;
    taxes.map((item) => {
        totalTaxes += item.value;
    });
    discounts.map((item) => {
        totalDiscounts += item.value;
    });
    fees && fees.map((item) => {
        totalFees += item.value;
    });
    return line_items.map(item => ({
        amount: item.product_data.total_price,
        label: item.product_data.product_title
    })).concat([
        { label: 'Discounts', amount: totalDiscounts },
        { label: 'Taxes', amount: totalTaxes },
        { label: 'Shipping', amount: shippingAmount },
        { label: 'Fees', amount: totalFees }
    ]);
}
exports.getPaymentRequestDisplayItems = getPaymentRequestDisplayItems;
